"use client";

import UserCertifications from "components/ui/v2/home/bundle/Dashboard/Certifications/UserCertifications";
import type { FormV2Props } from "../form-v2-props";
import { IUser } from "types/User.types";

export interface UserCertificationsModalContentV2Props extends FormV2Props {
  userCertificated?: IUser;
}

export function UserCertificationsModalContentV2({
  userCertificated,
  hideHeader = true
}: UserCertificationsModalContentV2Props) {
  return <UserCertifications userCertificated={userCertificated} hideHeader={hideHeader} />;
}
